import { Dialog } from '@base-ui/react/dialog'
import { styled } from 'styled-components'

// Enter/exit driven by Base UI's data-starting/ending-style attributes.
// Easing matches vaul's drawer curve.
const EASING = 'cubic-bezier(0.32, 0.72, 0, 1)'

export const Backdrop = styled(Dialog.Backdrop)`
  position: fixed;
  inset: 0;
  z-index: 1300;
  background: rgba(0, 0, 0, 0.5);
  opacity: 1;
  transition: opacity 280ms ${EASING};

  &[data-starting-style],
  &[data-ending-style] {
    opacity: 0;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const Popup = styled(Dialog.Popup)<{ $side: 'right' | 'left' }>`
  position: fixed;
  top: 0;
  bottom: 0;
  ${({ $side }) => ($side === 'left' ? 'left: 0;' : 'right: 0;')}
  z-index: 1301;
  display: flex;
  flex-direction: column;
  width: 420px;
  max-width: 100vw;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ $side }) =>
    $side === 'left'
      ? '8px 0 24px rgba(0, 0, 0, 0.12)'
      : '-8px 0 24px rgba(0, 0, 0, 0.12)'};
  outline: none;
  transform: translateX(0);
  transition: transform 320ms ${EASING};

  &[data-starting-style],
  &[data-ending-style] {
    transform: ${({ $side }) =>
      $side === 'left' ? 'translateX(-100%)' : 'translateX(100%)'};
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const Body = styled.div`
  flex: 1;
  overflow-y: auto;
  overscroll-behavior: contain;
`
